<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .quote-svg {
    display: flex;
    align-items: center;

    img {
      width: utils.in_rem(80px);
      height: auto;
    }
  }
</style>

<script>
  import svg from "../../../../assets/img/signup/quote.svg";
</script>

<div class="quote-svg">
  <img src={svg} alt="Quote" />
</div>
